/** The envelope every endpoint returns. */
export interface ApiResponse<T> {
  succeeded: boolean;
  message?: string | null;
  errors?: string[] | null;
  data?: T | null;
  version?: string | null;
}

/** Claims are `unknown` so readers check them instead of trusting a cast. */
export interface SalesClaims {
  roles?: unknown;
  id?: unknown;
  email?: unknown;
  name?: unknown;
  isMLGSalesRep?: unknown;
  adminView?: unknown;
  corporateScopeId?: unknown;
  sessionId?: unknown;
  iat?: unknown;
  exp?: unknown;
}

export const SALES_ROLE = 'Sales';
